export default __webpack_public_path__ + "static/media/page-v5-4.26072f88.png";